import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "why-g1g"
};
const _hoisted_2 = {
  class: "custom-container section-margin"
};
const _hoisted_3 = {
  class: "row mt-3 gy-5"
};
const _hoisted_4 = {
  class: "col-lg-3 col-md-6"
};
const _hoisted_5 = {
  class: "item"
};
const _hoisted_6 = {
  class: "head"
};
const _hoisted_7 = {
  class: "icon-container"
};
const _hoisted_8 = {
  class: "icon startup-launch"
};
const _hoisted_9 = {
  class: "icon arrow"
};
const _hoisted_10 = {
  class: "col-lg-3 col-md-6"
};
const _hoisted_11 = {
  class: "item"
};
const _hoisted_12 = {
  class: "head"
};
const _hoisted_13 = {
  class: "icon-container"
};
const _hoisted_14 = {
  class: "icon medical-hospital"
};
const _hoisted_15 = {
  class: "icon arrow"
};
const _hoisted_16 = {
  class: "col-lg-3 col-md-6"
};
const _hoisted_17 = {
  class: "item"
};
const _hoisted_18 = {
  class: "head"
};
const _hoisted_19 = {
  class: "icon-container"
};
const _hoisted_20 = {
  class: "icon travel-insurance"
};
const _hoisted_21 = {
  class: "icon arrow"
};
const _hoisted_22 = {
  class: "col-lg-3 col-md-6"
};
const _hoisted_23 = {
  class: "item"
};
const _hoisted_24 = {
  class: "head"
};
const _hoisted_25 = {
  class: "icon-container"
};
const _hoisted_26 = {
  class: "icon bacteria"
};
const _hoisted_27 = {
  class: "icon arrow"
};
import { track } from "@/analytics/events";
import { toRaw } from "vue";
import { uuid } from "vue-uuid";
import CloudinaryImage from "@/components/CloudinaryImage.vue";
import { createNamespacedHelpers } from "vuex-composition-helpers";
export default {
  __name: 'whyG1G',
  setup(__props) {
    const userStore = createNamespacedHelpers("user");
    const {
      getCustomerInfo
    } = userStore.useGetters(["getCustomerInfo"]);
    const trackSegment = event => {
      track(`${event}`, {
        customer_info: toRaw(getCustomerInfo.value),
        source: `Static Clickable ${event}`,
        event: uuid.v4()
      });
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[16] || (_cache[16] = _createStaticVNode("<div class=\"row gy-4 d-flex align-items-center\" data-v-05ab5462><div class=\"col-md-6\" data-v-05ab5462><h3 class=\"\" data-v-05ab5462>Why G1G is the best place to buy Travel Insurance.</h3></div><div class=\"col-md-6\" data-v-05ab5462><h5 class=\"description-body mb-0\" data-v-05ab5462>Welcome to care that meets your needs. See how we’re building a better experience for people just like you.</h5></div></div>", 1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, [_createVNode(CloudinaryImage, {
        alt: "startup launch",
        imageName: "startup-launch_func1s.svg"
      })])]), _cache[4] || (_cache[4] = _createElementVNode("h5", {
        class: "title"
      }, "Protect ", -1))]), _cache[6] || (_cache[6] = _createElementVNode("p", {
        class: "description"
      }, "Learn how G1G built the ultimate platform to keep travelers safe.", -1)), _createVNode(_component_router_link, {
        to: "/how-g1g-works-best-travel-insurance",
        onClick: _cache[0] || (_cache[0] = $event => trackSegment('Learn more - Protect'))
      }, {
        default: _withCtx(() => [_cache[5] || (_cache[5] = _createTextVNode(" Learn more ")), _createElementVNode("span", _hoisted_9, [_createVNode(CloudinaryImage, {
          imageName: "blue-arrow_dkv7bg.svg",
          alt: "arrow"
        })])]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, [_createVNode(CloudinaryImage, {
        imageName: "medical-hospital_egvgud.svg",
        alt: "medical hospital"
      })])]), _cache[7] || (_cache[7] = _createElementVNode("h5", {
        class: "title"
      }, "Support", -1))]), _cache[9] || (_cache[9] = _createElementVNode("p", {
        class: "description"
      }, "Find answers to all of your questions about travel insurance.", -1)), _createVNode(_component_router_link, {
        to: "/faq",
        onClick: _cache[1] || (_cache[1] = $event => trackSegment('Learn more - Support'))
      }, {
        default: _withCtx(() => [_cache[8] || (_cache[8] = _createTextVNode(" Learn more ")), _createElementVNode("span", _hoisted_15, [_createVNode(CloudinaryImage, {
          imageName: "blue-arrow_dkv7bg.svg",
          alt: "arrow"
        })])]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_router_link, {
        to: "about-us"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, [_createVNode(CloudinaryImage, {
          imageName: "travel-insuranc_omhl6z.svg",
          alt: "travel insurance"
        })])]), _cache[10] || (_cache[10] = _createElementVNode("h5", {
          class: "title"
        }, "Heritage", -1))]), _cache[12] || (_cache[12] = _createElementVNode("p", {
          class: "description"
        }, "We know what it’s like to be in your shoes. It’s why we’re here.", -1)), _createVNode(_component_router_link, {
          to: "/about-us",
          onClick: _cache[2] || (_cache[2] = $event => trackSegment('Learn more - Heritage'))
        }, {
          default: _withCtx(() => [_cache[11] || (_cache[11] = _createTextVNode(" Our story ")), _createElementVNode("span", _hoisted_21, [_createVNode(CloudinaryImage, {
            imageName: "blue-arrow_dkv7bg.svg",
            alt: "arrow"
          })])]),
          _: 1
        })])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("span", _hoisted_26, [_createVNode(CloudinaryImage, {
        imageName: "science-bacteri_gylorm.svg",
        alt: "science bacteria"
      })])]), _cache[13] || (_cache[13] = _createElementVNode("h5", {
        class: "title"
      }, "Mission", -1))]), _cache[15] || (_cache[15] = _createElementVNode("p", {
        class: "description"
      }, "We’re on a mission to make the world a safer place for travelers.", -1)), _createVNode(_component_router_link, {
        to: "/our-mission",
        onClick: _cache[3] || (_cache[3] = $event => trackSegment('Learn more - Mission'))
      }, {
        default: _withCtx(() => [_cache[14] || (_cache[14] = _createTextVNode(" Our mission ")), _createElementVNode("span", _hoisted_27, [_createVNode(CloudinaryImage, {
          imageName: "blue-arrow_dkv7bg.svg",
          alt: "arrow"
        })])]),
        _: 1
      })])])])])]);
    };
  }
};